export default __webpack_public_path__ + "6d82169f26ff6392efb2dfedb42a0d53.png";